export default {
    init() {
        // JavaScript to be fired on the home page
    },
    finalize() {
        $('.slider-home').slick({
            slidesToShow: 1,
            dots: true,
            infinite: false,
            autoplay: true,
            prevArrow: '<button type="button" class="slick-prev">Previous</button>',
            nextArrow: '<button type="button" class="slick-next">Next</button>',
            autoplaySpeed: 3000,
            dotsClass: 'custom-dots',
            arrows: true,
            customPaging: function (slider, i) {
                var slideNumber = i + 1,
                    totalSlides = slider.slideCount;
                return '<a class="dot" role="button" title="' + slideNumber + ' of ' + totalSlides + '"></a>';
            },
        });

        $('.slider-boats').slick({
            centerMode: true,
            centerPadding: '0px',
            slidesToShow: 3,
            autoplay: true,
            infinite: false,
            initialSlide: 1,
            dots: false,
            responsive: [
                {
                    breakpoint: 990,
                    settings: {
                        centerMode: true,
                        centerPadding: '0px',
                        slidesToShow: 1,
                    },
                },
            ],
        });

        $('.slider-boats').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            var familles = $('.slickGoTo');
            $(familles).removeClass('famille-active');

            for (var i = 0; i < familles.length; i++) {
                var index = $(familles[i]).attr('data-slick');
                if (index == nextSlide) {
                    $(familles[i]).addClass('famille-active');
                }
            }
        });
        $('.slickGoTo').click(function (e) {
            e.preventDefault();
            var goTo = $(this).attr('data-slick');
            $('.slider-boats').slick('slickGoTo', parseInt(goTo));
        });
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js